
export enum AccountActivityStatNameKey {
  ORGANIC_POSTS = 'grade.accountActivity.benchmark.organicPosts',
  ADS_CREATED = 'grade.accountActivity.benchmark.adsCreated',
  ADS_CHANGED = 'grade.accountActivity.benchmark.adsChanged',
  AUDIENCE_CHANGE = 'grade.accountActivity.benchmark.audienceChange',
  TOTAL_ACTIVITY = 'grade.accountActivity.benchmark.totalActivity'
}
